import type { App } from 'vue';

type Options = {
  apiKey: string;
};

export const placesPlugin = {
  install(_app: App, { apiKey }: Options) {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    document.body.appendChild(script);
  },
};
